import { useQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/companies/constants';

import { companiesQueryKeys } from './queryKeys';

/**
 * The company that owns the company's website in Coresignal, for "Is this your company?"; null when nothing does.
 * finlay-api looks each website up once and keeps the answer, so asking again costs nothing; a failure isn't retried
 * and leaves the user to pick their size and industry themselves.
 */
export const useCompanyLookupQuery = (companyId: string) =>
  useQuery({
    queryKey: companiesQueryKeys.profileLookup(companyId),
    queryFn: async () => {
      const { data } = await fetchClient.POST(endpoints.companyProfileLookup, {
        params: { path: { id: companyId } },
      });
      return data?.company ?? null;
    },
    enabled: Boolean(companyId),
    retry: false,
    staleTime: Infinity,
  });
